import {SystemUser} from '../../models/system-user.model';
import {ResetPasswordRequest} from '../../models/reset-password-request.model';

export namespace AuthActions {
    export class LoginUser {
        static readonly type = 'AuthAction.LoginUser';

        constructor(public login: string, public password: string) {
        }
    }

    export class AuthSuccess {
        static readonly type = 'AuthAction.AuthSuccess';

        constructor(public user: SystemUser) {
        }
    }

    export class AuthFailure {
        static readonly type = 'AuthAction.AuthFailure';
    }

    export class Logout {
        static readonly type = 'AuthAction.Logout';
    }

    export class LogoutRequest {
        static readonly type = 'AuthAction.LogoutRequest';
    }

    export class PasswordForgotten {
        static readonly type = 'AuthAction.PasswordForgotten';

        constructor(public username: string) {
        }
    }

    export class PasswordReset {
        static readonly type = 'AuthAction.PasswordReset';

        constructor(public token: string, public formData: ResetPasswordRequest) {
        }
    }

    export class GetPasswordPolicy {
        static readonly type = 'AuthActions.GetPasswordPolicy';

        constructor(public token: string) {
        }
    }

    export class OldPasswordReset {
        static readonly type = 'AuthAction.OldPasswordReset';
    }
}

